import { ShoppingBag, UserPlus, MessageCircle } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export const MobileCTA = () => {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 lg:hidden"
      data-testid="mobile-sticky-cta-bar"
    >
      <div className="grid grid-cols-3">
        <button onClick={() => scrollToId("products")} className="flex h-14 flex-col items-center justify-center gap-0.5 text-xs font-medium text-foreground" data-testid="mobile-cta-shop">
          <ShoppingBag className="h-5 w-5 text-primary" />
          Shop
        </button>
        <button onClick={() => scrollToId("join")} className="flex h-14 flex-col items-center justify-center gap-0.5 border-x border-border text-xs font-medium text-foreground" data-testid="mobile-cta-join">
          <UserPlus className="h-5 w-5 text-accent" />
          Sali
        </button>
        <button onClick={() => scrollToId("contact")} className="flex h-14 flex-col items-center justify-center gap-0.5 text-xs font-medium text-foreground" data-testid="mobile-cta-contact">
          <MessageCircle className="h-5 w-5 text-primary" />
          Contact
        </button>
      </div>
    </div>
  );
};
